import React, { ReactElement } from 'react';
import { KImage } from '@/component/RtlLayout';
import { ScrollView, View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { useDetailPageStore } from '@/page/detail/store';
import CouponMiniV2 from './ConponMiniV2';
import { scaleW } from '@/common/style';
import { KTouchableWithoutFeedback } from '@/component/RtlLayout/Touchable';
import { isMobileDevice } from '@/common/device-info';
import './index.css';

function CouponEntry(): ReactElement {
    const { pageRawData, showMoreCouponPop } = useDetailPageStore(s => ({
        pageRawData: s.pageRawData,
        showMoreCouponPop: s.showMoreCouponPop,
    }));

    // discountCoupon 就是 couponList
    return pageRawData && pageRawData.discountCoupon?.length ? (
        <div>
            <KTouchableWithoutFeedback onPress={() => showMoreCouponPop()}>
                <View
                    style={{"marginTop":"1.9323671497584543rem","display":"flex","alignItems":"flex-start","overflow":"hidden"}}>
                    <div className="coupon-scroll-wrapper">
                        {pageRawData.discountCoupon.map(dicountCoupon => (
                            <View style={{"marginRight":"1.9323671497584543rem"}}>
                                <CouponMiniV2 couponInfo={dicountCoupon} />
                            </View>
                        ))}
                    </div>
                    {pageRawData.discountCoupon.length > 1 ? (
                        <View
                            style={{"position":"absolute","top":"0rem","right":"0rem","flexDirection":"row"}}>
                            <LinearGradient
                                style={{"width":"4.830917874396135rem","marginRight":"-1.9323671497584543rem"}}
                                start={{ x: 0, y: 0 }}
                                end={{ x: 1, y: 0 }}
                                colors={['rgba(255,255,255,0)', 'rgba(255,255,255,1)']}
                            />
                            <View
                                style={{"width":"0.9661835748792271rem","height":"100%","backgroundColor":"white"}}
                            />
                            <KImage
                                source={{ uri: 'https://cdn-static.kwai.net/kos/s101/nlav11312/shop-krn/Frame_1942972514.png' }}
                                style={{
                                    width: isMobileDevice ? scaleW(32) : scaleW(28),
                                    height: isMobileDevice ? scaleW(32) : scaleW(28),
                                    backgroundColor: 'white',
                                }}
                            />
                        </View>
                    ) : null}
                </View>
            </KTouchableWithoutFeedback>
        </div>
    ) : null;
}

export default CouponEntry;
